export default class FeatureBlock {
  static init() {
    const block = document.querySelector('[data-module="feature-block"]');

    if (!block) {
      return;
    }

    block.classList.add('is-ready');
  }
}
